<template>
  <div>
    <div class="search-content">

      <el-col :span="24" class="toobar">
        <el-row>
          <el-col :span="24">
            <el-select v-model="cangkucode" @change="bindGrid" filterable style="width: 100px" size="mini">
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                         :label="item.cangkuname"
                         :value="item.cangkucode">
              </el-option>
            </el-select>
            <el-select v-model="selectedFillTemplate" @change="bindGrid(false)" filterable clearable
                       placeholder="品类" size="mini" style="width: 80px; margin-left: 10px">
              <el-option v-for="item in filltemplateOptions" :key="item.value"
                         :label="item.label" :value="item.value"/>
            </el-select>
            <el-select v-model="selectedBrandCodes" @change="bindGrid(false)" multiple collapse-tags
                       filterable clearable placeholder="品牌" size="mini" style="width: 150px; margin-left: 10px">
              <el-option v-for="item in brandList" :key="item.categorycode"
                         :label="item.categoryname" :value="item.categorycode"/>
            </el-select>
            <el-input placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel" size="mini" style="width: 150px"
                      @clear="clearSeedCode">
            </el-input>
            <el-input style="width:160px;" size="mini"
                      placeholder="输入销售单号或采购单号"
                      prefix-icon="el-icon-search"
                      v-model="searchdata" clearable>
            </el-input>
            <el-date-picker
              v-model="date" size="mini"
              type="month" style="width:120px;"
              v-if="radio2=='0'" :clearable="false"
              placeholder="选择日期">
            </el-date-picker>
            <el-date-picker
              v-model="searchDateRange" size="mini"
              type="daterange" style="width:240px;"
              v-if="radio2=='4'||radio2=='5'"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
            <el-input style="width:160px;" size="mini"
                      placeholder="坏件单号"
                      v-model="searchErpserial"
                      v-if="radio2=='4'||radio2=='5'"
                      clearable>
            </el-input>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="bindGrid(false)">搜索</el-button>
            <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
            <el-button type="warning" v-on:click="addstoragebad(1)" size="mini">供应商多发（镜片）</el-button>
            <el-dropdown  @command="handleDropCommand"  >
              <el-button type="warning" size="mini">正式库转入</el-button>
              <el-dropdown-menu slot="dropdown" style="font-size: larger">
                <el-dropdown-item command="len">镜片</el-dropdown-item>
                <el-dropdown-item command="frame">镜架</el-dropdown-item>
                <el-dropdown-item command="lenqrcode" v-if="qrcodescan">镜片-扫码</el-dropdown-item>
                <el-dropdown-item command="frameqrcode" v-if="qrcodescan">镜架-扫码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="handleExportCommand">
              <el-button type="warning" size="mini">导出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="summary">导出待处理汇总表</el-dropdown-item>
                <el-dropdown-item command="in">坏件入库明细</el-dropdown-item>
                <el-dropdown-item command="out">坏件出库明细</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="danger" size="mini" @click="scanHandleShow">扫码处理</el-button>
            <!--<el-button type="warning" v-on:click="importEdit">导入</el-button>-->
            <!--<a href="./static/file/坏件库导入模板.xls">下载模板</a>-->
          </el-col>
        </el-row>
        <el-row>
          <el-radio-group v-model="radio2" size="mini" @change="bindGrid(false)" style="margin-top: 10px">
            <el-radio-button :label="'1'" :key="'1'">待收货</el-radio-button>
            <el-radio-button :label="'2'" :key="'2'">待处理</el-radio-button>
            <el-radio-button :label="'3'" :key="'3'" v-if="badoutaudit">待审核</el-radio-button>
            <el-radio-button :label="'4'" :key="'4'">坏件入库单</el-radio-button>
            <el-radio-button :label="'5'" :key="'5'">坏件出库单</el-radio-button>
            <el-radio-button :label="'0'" :key="'0'">汇总</el-radio-button>
          </el-radio-group>
        </el-row>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight(115)"
      size="mini"
      stripe
      border
      v-if="radio2==1"
      style="width: 100%;">
      <el-table-column
        width="50"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index}}
        </template>
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="erpserial" width="120"-->
        <!--label="单号"-->
        <!--header-align="center"-->
        <!--align="center" >-->
      <!--</el-table-column>-->
      <el-table-column
        prop="seedname"
        label="名称" width="180"
        :show-overflow-tooltip="true"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="编码"
        header-align="center"
        width="120" :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="packagesize"
        label="规格"
        align="left" :show-overflow-tooltip="true"
        header-align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="ordername"
        label="类别"
        align="left"
        header-align="center"
        width="80">
      </el-table-column>
      <el-table-column
        label="品类"
        align="center"
        header-align="center"
        width="80">
        <template slot-scope="scope">
          {{ formatFillTemplate(scope.row.filltemplate) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="pinpaigoryname"
        label="品牌"
        align="center"
        header-align="center"
        width="80"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="原因" :show-overflow-tooltip="true"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="cangkuname"
        label="仓库"
        header-align="center" :show-overflow-tooltip="true"
        align="left"
        width="70">
      </el-table-column>
      <el-table-column
        prop="totalnumber"
        label="数量"
        header-align="center"
        align="center"
        width="70">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="uname"-->
        <!--label="录入人"-->
        <!--header-align="center"-->
        <!--align="center"-->
        <!--width="100">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="adddate"
        label="录入日期"
        header-align="center"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="ordernum"
        label="销售单号"
        header-align="center"
        align="center"
        width="120" >
      </el-table-column>
      <el-table-column label="操作" align="center" width="70" >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="confirmruku(scope.row)">入库
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <BaoSunDetail ref="BaoSunDetail" @bindGrid="bindGrid"></BaoSunDetail>
    <el-table
      :data="tableData"
      :height="tableHeight(115)"
      size="mini"
      stripe
      border
      show-summary
      :summary-method="getSummaries"
      v-if="radio2==2"
      style="width: 100%;">
      <el-table-column
        width="50"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index}}
        </template>
      </el-table-column>
      <el-table-column
        prop="cangkuname"
        label="仓库"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left"
        width="100">
      </el-table-column>
      <el-table-column
        prop="CategoryName" width="80"
        label="品牌"
        header-align="center"
        :show-overflow-tooltip="true"
        align="center">
      </el-table-column>
      <el-table-column
        label="品类"
        align="center"
        header-align="center"
        width="80">
        <template slot-scope="scope">
          {{ formatFillTemplate(scope.row.FillTemplate) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="seedname"
        label="名称"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="编码"
        header-align="center"
        width="110"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="tuihuo"
        label="销售退货"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="zhuanru"
        label="正式转出"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="zhiliang"
        label="质检问题"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="jiagongbaosun"
        label="加工损坏"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="duofa"
        label="供应商多发"
        header-align="center"
        align="center"
        width="90" >
      </el-table-column>
      <el-table-column label="操作" align="center" width="80" >
        <template slot-scope="scope">
          <el-button v-if="radio2==2"
                     size="mini"
                     type="primary"
                     @click="handleEdit(scope.row)">处理
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <StorageBadEdit ref="StorageBadEdit" @bindGrid="bindGrid"></StorageBadEdit>
    <BadScanHandle ref="BadScanHandle" @bindGrid="bindGrid"></BadScanHandle>
    <StorageBadDetail ref="StorageBadDetail" @bindGrid="bindGrid"></StorageBadDetail>
    <AddStorageBad ref="AddStorageBad" @bindGrid="bindGrid" @openDetail="openDetail"></AddStorageBad>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <AddStorageBadFrame ref="AddStorageBadFrame" @bindGrid="bindGrid" @openDetail="openDetail"></AddStorageBadFrame>
    <AddStorageBadQRCode ref="AddStorageBadQRCode" @bindGrid="bindGrid" @openDetail="openDetail"></AddStorageBadQRCode>
    <StorageBadSummary ref="StorageBadSummary1"></StorageBadSummary>
    <el-table
      :data="tableData"
      :height="tableHeight(115)"
      size="mini"
      stripe
      border
      v-if="radio2==3"
      style="width: 100%;">
      <el-table-column width="50" label="序号" align="center">
        <template slot-scope="scope">{{1+scope.$index}}</template>
      </el-table-column>
      <el-table-column prop="displayErpserial" label="出库单号" width="140" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column prop="handlemodeText" label="处理方式" width="90" align="center"></el-table-column>
      <el-table-column prop="cangkuname" label="仓库" width="100" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column prop="uname" label="操作人" width="80" align="center"></el-table-column>
      <el-table-column prop="adddate" label="申请时间" width="150" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openAudit(scope.row.erpserial)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <StorageBadAudit ref="StorageBadAudit" @bindGrid="bindGrid"></StorageBadAudit>
    <StorageBadOut ref="StorageBadOut"></StorageBadOut>
    <el-table
      :data="tableData4"
      :height="tableHeight(160)"
      size="mini"
      stripe
      border
      v-if="radio2=='4'"
      style="width: 100%;">
      <el-table-column width="50" label="序号" align="center">
        <template slot-scope="scope">{{(pagination4.currentPage-1)*pagination4.pageSize+1+scope.$index}}</template>
      </el-table-column>
      <el-table-column prop="adddate" label="入库日期" width="150" align="center"></el-table-column>
      <el-table-column prop="erpserial" label="坏件入库单号" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="lookInbound(scope.row)">{{scope.row.erpserial}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="ordernum" label="销售单号" width="120" align="center"></el-table-column>
      <el-table-column prop="buyordernum" label="采购单号" width="120" align="center"></el-table-column>
      <el-table-column prop="seedname" label="商品名称" min-width="150" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column prop="seedcode" label="商品编码" width="110" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column prop="qj" label="球镜" width="70" align="center"></el-table-column>
      <el-table-column prop="zj" label="柱镜" width="70" align="center"></el-table-column>
      <el-table-column prop="xh" label="型号" width="80" align="center"></el-table-column>
      <el-table-column prop="sh" label="色号" width="70" align="center"></el-table-column>
      <el-table-column prop="totalnumber" label="入库数量" width="80" align="center"></el-table-column>
      <el-table-column prop="customername" label="责任人" width="100" align="center">
        <template slot-scope="scope">
          <span style="white-space: nowrap">{{ scope.row.customername }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uname" label="录入人" width="80" align="center"></el-table-column>
      <el-table-column prop="ordername" label="类别" width="90" align="center"></el-table-column>
      <el-table-column label="品类" width="80" align="center">
        <template slot-scope="scope">
          {{ formatFillTemplate(scope.row.filltemplate) }}
        </template>
      </el-table-column>
      <el-table-column prop="pinpaigoryname" label="品牌" width="80" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="cangkuname" label="仓库" width="80" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column prop="remark" label="原因" min-width="120" :show-overflow-tooltip="true" align="left"></el-table-column>
    </el-table>
    <el-pagination
      v-if="radio2=='4'"
      @size-change="handleSizeChange4"
      @current-change="handleCurrentChange4"
      :current-page="pagination4.currentPage"
      :page-sizes="[20, 50, 100]"
      :page-size="pagination4.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination4.total"
      style="margin-top: 10px;">
    </el-pagination>
    <el-table
      :data="tableData5"
      :height="tableHeight(160)"
      size="mini"
      stripe
      border
      v-if="radio2=='5'"
      style="width: 100%;">
      <el-table-column width="50" label="序号" align="center">
        <template slot-scope="scope">{{(pagination5.currentPage-1)*pagination5.pageSize+1+scope.$index}}</template>
      </el-table-column>
      <el-table-column prop="adddate" label="出库日期" width="150" align="center"></el-table-column>
      <el-table-column prop="erpserial" label="坏件出库单号" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="lookOutbound(scope.row)">{{scope.row.erpserial}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="ordernum" label="坏件入库单号" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="lookInboundFromOut(scope.row)">{{scope.row.ordernum}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="seedname" label="商品名称" min-width="150" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column prop="seedcode" label="商品编码" width="110" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column prop="qj" label="球镜" width="70" align="center"></el-table-column>
      <el-table-column prop="zj" label="柱镜" width="70" align="center"></el-table-column>
      <el-table-column prop="xh" label="型号" width="80" align="center"></el-table-column>
      <el-table-column prop="sh" label="色号" width="70" align="center"></el-table-column>
      <el-table-column prop="totalnumber" label="出库数量" width="80" align="center"></el-table-column>
      <el-table-column prop="uname" label="操作人" width="80" align="center"></el-table-column>
      <el-table-column prop="handlemode" label="处理方式" width="90" align="center"></el-table-column>
      <el-table-column label="品类" width="80" align="center">
        <template slot-scope="scope">
          {{ formatFillTemplate(scope.row.filltemplate) }}
        </template>
      </el-table-column>
      <el-table-column prop="pinpaigoryname" label="品牌" width="80" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="cangkuname" label="仓库" width="80" :show-overflow-tooltip="true" align="left"></el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" :show-overflow-tooltip="true" align="left"></el-table-column>
    </el-table>
    <el-pagination
      v-if="radio2=='5'"
      @size-change="handleSizeChange5"
      @current-change="handleCurrentChange5"
      :current-page="pagination5.currentPage"
      :page-sizes="[20, 50, 100]"
      :page-size="pagination5.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination5.total"
      style="margin-top: 10px;">
    </el-pagination>
    <el-dialog :title="exportDialogTitle" :visible.sync="exportDialogVisible" width="430px" append-to-body>
      <el-form :model="exportForm" ref="exportForm" :rules="exportRules" label-width="90px">
        <el-form-item label="仓库" prop="cangkucode">
          <el-select v-model="exportForm.cangkucode" filterable placeholder="请选择仓库" style="width: 100%" size="small">
            <el-option v-for="item in jxcstoreData" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围" prop="daterange">
          <el-date-picker
            v-model="exportForm.daterange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
            size="small"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="exportDialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmExport" size="small" :loading="exportLoading">确定导出</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {brokengoodslist, badpartsimport, badpartslist, badpartsinlist, badpartsoutlist, badpartsauditlist, badpartsinpage, badpartsoutpage} from '@/api/set/warehouse'
  import {listLens} from '@/api/set/jxcgoodscategory'
  import StorageBadDetail from './StorageBadDetail';
  import StorageBadEdit from './StorageBadEdit';
  import BadScanHandle from './BadScanHandle';
  import AddStorageBadFrame from './AddStorageBadFrame'
  import AddStorageBadQRCode from './AddStorageBadQRcode'
  import AddStorageBad from './AddStorageBad';
  import StorageBadAudit from './StorageBadAudit';
  import StorageBadOut from './StorageBadOut';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {updatebadparts, badpartscount, completedcount} from '@/api/set/jxcstoreformdetail';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'
  import {checkModuleRight} from '@/api/login'
  import StorageBadSummary from "./StorageBadSummary";

  export default {
    name: 'StorageBad',
    data() {
      return {
        msg:'坏件库管理主页',
        userInfoModel: {},
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        independentserial: "",
        jxcstoreData:[],
        tableData: [],
        cangkucode: '',
        radio2: 1,
        oldradio:1,
        handlemode: '',
        canshowgoodsel:true,
        seedname: '',
        seedcode: '',
        date: '',
        qrcodescan:false,
        badoutaudit:false,
        searchErpserial: '',
        searchDateRange: [],
        tableData4: [],
        tableData5: [],
        pagination4: { currentPage: 1, pageSize: 20, total: 0 },
        pagination5: { currentPage: 1, pageSize: 20, total: 0 },
        exportDialogVisible: false,
        exportType: '',
        exportLoading: false,
        exportForm: {
          cangkucode: '',
          daterange: []
        },
        exportRules: {
          cangkucode: [{ required: true, message: '请选择仓库', trigger: 'change' }],
          daterange: [{ required: true, message: '请选择时间范围', trigger: 'change' }]
        },
        selectedFillTemplate: "",
        filltemplateOptions: [
          { label: "镜片", value: "10,20" },
          { label: "现片", value: "10" },
          { label: "定制", value: "20" },
          { label: "加工", value: "50" },
          { label: "镜架", value: "80" },
          { label: "其他", value: "40" }
        ],
        selectedBrandCodes: [],
        brandList: []
      }
    },
    props: {
      cangkucodes: {type: Array, default: () => []},
      cangkuname: {default: ""},
    },
    computed: {
      exportDialogTitle() {
        return this.exportType === 'in' ? '坏件入库明细导出' : '坏件出库明细导出'
      }
    },
    methods: {
      loadBrandList() {
        listLens({ enable: 1 }).then(res => {
          this.brandList = res.data.obj || []
        })
      },
      formatFillTemplate(val) {
        if (val === '10' || val === '20' || val === 10 || val === 20) return '镜片'
        if (val === '50' || val === 50) return '加工'
        if (val === '80' || val === 80) return '镜架'
        if (val === '40' || val === 40) return '其他'
        return val || ''
      },
      buildFilterParams() {
        const params = {}
        if (this.selectedFillTemplate) params.filltemplate = this.selectedFillTemplate
        if (this.selectedBrandCodes.length > 0) params.categorycode = this.selectedBrandCodes.join(",")
        return params
      },
      //导出
      excelPort() {
        var data = this.tableData;

        var date = new Date();
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        let header1 = ["仓库","品牌","名称","编码","品类","销售退货","正式转入","质量问题","加工损坏","供应商多发"]
        let column1 = ["cangkuname","CategoryName","seedname","seedcode","pinpai","tuihuo","zhuanru","zhiliang","jiagongbaosun","duofa"]

        data = data.map(item => {
          return { ...item, pinpai: this.formatFillTemplate(item.FillTemplate) }
        })

        var name = '坏件库'+(this.radio2=='0'?'汇总':'待处理') + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)
        this.$exportExcel(header1, column1, data, name)
      },
      //导出下拉
      handleExportCommand(command) {
        if (command === 'summary') {
          if (this.radio2 == '1') {
            this.$message.warning('请先切换到"待处理"或"汇总"页签后再导出')
            return
          }
          this.excelPort()
        } else {
          this.exportType = command
          const end = new Date()
          const start = new Date()
          start.setMonth(start.getMonth() - 1)
          const fmt = (dt) => {
            return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0')
          }
          this.exportForm = {
            cangkucode: this.cangkucode || '',
            daterange: [fmt(start), fmt(end)]
          }
          this.exportDialogVisible = true
        }
      },
      confirmExport() {
        this.$refs.exportForm.validate((valid) => {
          if (valid) {
            if (this.exportType === 'in') {
              this.excelPortIn()
            } else {
              this.excelPortOut()
            }
          }
        })
      },
      parsePackagesize(packagesize) {
        let result = { qj: '', zj: '', xh: '', sh: '' }
        if (packagesize) {
          try {
            let temp = JSON.parse(packagesize)
            if (temp.M) {
              result.xh = temp.M || ''
              result.sh = temp.C || ''
            } else {
              result.qj = (temp.Y != null && temp.Y !== '') ? temp.Y : ''
              result.zj = (temp.X != null && temp.X !== '') ? temp.X : ''
            }
          } catch (e) {}
        }
        return result
      },
      excelPortIn() {
        this.exportLoading = true
        const apiParams = Object.assign({
          cangkucode: this.exportForm.cangkucode,
          startdate: this.exportForm.daterange[0],
          enddate: this.exportForm.daterange[1]
        }, this.buildFilterParams())
        badpartsinlist(apiParams).then(response => {
          this.exportLoading = false
          const list = response.data.obj || []
          const data = list.map(item => {
            const ps = this.parsePackagesize(item.packagesize)
            return {
              adddate: item.adddate,
              erpserial: item.erpserial,
              ordernum: item.ordernum,
              buyordernum: item.buyordernum,
              seedname: item.seedname,
              seedcode: item.seedcode,
              qj: ps.qj,
              zj: ps.zj,
              xh: ps.xh,
              sh: ps.sh,
              totalnumber: item.totalnumber,
              customername: item.customername,
              uname: item.uname,
              ordername: item.ordername,
              pinpai: this.formatFillTemplate(item.filltemplate),
              pinpaigoryname: item.pinpaigoryname || '',
              cangkuname: item.cangkuname,
              remark: item.remark
            }
          })
          const header = ['入库日期', '坏件入库单号', '销售单号', '采购单号', '商品名称', '商品编码', '球镜', '柱镜', '型号', '色号', '入库数量', '责任人', '录入人', '类别', '品类', '品牌', '仓库', '原因']
          const column = ['adddate', 'erpserial', 'ordernum', 'buyordernum', 'seedname', 'seedcode', 'qj', 'zj', 'xh', 'sh', 'totalnumber', 'customername', 'uname', 'ordername', 'pinpai', 'pinpaigoryname', 'cangkuname', 'remark']
          this.$exportExcel(header, column, data, '坏件入库明细')
          this.exportDialogVisible = false
        }).catch(() => {
          this.exportLoading = false
        })
      },
      excelPortOut() {
        this.exportLoading = true
        const apiParams = Object.assign({
          cangkucode: this.exportForm.cangkucode,
          startdate: this.exportForm.daterange[0],
          enddate: this.exportForm.daterange[1]
        }, this.buildFilterParams())
        badpartsoutlist(apiParams).then(response => {
          this.exportLoading = false
          const list = response.data.obj || []
          const data = list.map(item => {
            const ps = this.parsePackagesize(item.packagesize)
            return {
              adddate: item.adddate,
              erpserial: item.erpserial,
              ordernum: item.ordernum,
              seedname: item.seedname,
              seedcode: item.seedcode,
              qj: ps.qj,
              zj: ps.zj,
              xh: ps.xh,
              sh: ps.sh,
              totalnumber: item.totalnumber,
              uname: item.uname,
              handlemode: item.handlemode,
              pinpai: this.formatFillTemplate(item.filltemplate),
              pinpaigoryname: item.pinpaigoryname || '',
              cangkuname: item.cangkuname,
              remark: item.remark
            }
          })
          const header = ['出库日期', '坏件出库单号', '坏件入库单号', '商品名称', '商品编码', '球镜', '柱镜', '型号', '色号', '出库数量', '操作人', '处理方式', '品类', '品牌', '仓库', '备注']
          const column = ['adddate', 'erpserial', 'ordernum', 'seedname', 'seedcode', 'qj', 'zj', 'xh', 'sh', 'totalnumber', 'uname', 'handlemode', 'pinpai', 'pinpaigoryname', 'cangkuname', 'remark']
          this.$exportExcel(header, column, data, '坏件出库明细')
          this.exportDialogVisible = false
        }).catch(() => {
          this.exportLoading = false
        })
      },
      handleDropCommand(command){
        switch (command){
          case 'len':
            this.addstoragebad(2);
            break;
          case 'frame':
            this.addstoragebadFrame(2);
            break;
          case 'lenqrcode':
            this.addstoragebadQRcode('len');
            break;
          case 'frameqrcode':
            this.addstoragebadQRcode('frame');
            break;
        }
      },
      useFrame(){
        if(localStorage.getItem("hpapi_usemodel")&&localStorage.getItem("hpapi_usemodel")=='noframe'){
          return false;
        }
        return true;
      },
      addstoragebadFrame(type) {
        this.$refs.AddStorageBadFrame.show()
        this.$refs.AddStorageBadFrame.initData(type)
      },
      addstoragebadQRcode(type) {
        this.$refs.AddStorageBadQRCode.show()
        this.$refs.AddStorageBadQRCode.initData(type)
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
        this.bindGrid()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.bindGrid()
      },
      //合计
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index <=4) {
            sums[index] = '';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              badpartsimport({data: JSON.stringify(data)}).then((response) => {
                if (response.data.code == 0) {
                  this.$message({
                    message: '导入成功',
                    type: 'success'
                  })
                } else {
                  this.$message({
                    message: '导入失败',
                    type: 'error'
                  })
                }
              })
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      //导入记录
      importEdit() {
        this.$refs.fileupload1.value = ""
        var message = '是否导入坏件？'
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.fileupload1.click()
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          if (temp.M) {
            s = temp.M + '-' + temp.C;
          } else {
            s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          }
        }
        return s
      },
      handleEdit(row) {
        this.$refs.StorageBadEdit.initData(row)
      } ,
      openAudit(erpserial) {
        this.$refs.StorageBadAudit.show(erpserial)
      },
      lookInbound(row) {
        this.$refs.BaoSunDetail.show(row.erpserial, true)
      },
      lookOutbound(row) {
        this.$refs.StorageBadOut.show(row.erpserial)
      },
      lookInboundFromOut(row) {
        this.$refs.BaoSunDetail.show(row.ordernum, true)
      },
      handleSizeChange4(val) {
        this.pagination4.pageSize = val
        this.pagination4.currentPage = 1
        this.loadTab4()
      },
      handleCurrentChange4(val) {
        this.pagination4.currentPage = val
        this.loadTab4()
      },
      handleSizeChange5(val) {
        this.pagination5.pageSize = val
        this.pagination5.currentPage = 1
        this.loadTab5()
      },
      handleCurrentChange5(val) {
        this.pagination5.currentPage = val
        this.loadTab5()
      },
      getDefaultDateRange() {
        const end = new Date()
        const start = new Date()
        start.setMonth(start.getMonth() - 1)
        const fmt = (dt) => {
          return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0')
        }
        return [fmt(start), fmt(end)]
      },
      loadTab4() {
        const params = Object.assign({
          offset: (this.pagination4.currentPage - 1) * this.pagination4.pageSize,
          limit: this.pagination4.pageSize,
          cangkucode: this.cangkucode,
          seedcode: this.seedcode,
          search: this.searchdata,
          erpserial: this.searchErpserial
        }, this.buildFilterParams())
        if (this.searchDateRange && this.searchDateRange.length === 2) {
          params.startdate = this.searchDateRange[0]
          params.enddate = this.searchDateRange[1]
        }
        badpartsinpage(params).then(response => {
          const pageData = response.data.obj || {}
          this.tableData4 = (pageData.rows || []).map(item => {
            const ps = this.parsePackagesize(item.packagesize)
            return { ...item, qj: ps.qj, zj: ps.zj, xh: ps.xh, sh: ps.sh }
          })
          this.pagination4.total = pageData.total || 0
        })
      },
      loadTab5() {
        const params = Object.assign({
          offset: (this.pagination5.currentPage - 1) * this.pagination5.pageSize,
          limit: this.pagination5.pageSize,
          cangkucode: this.cangkucode,
          seedcode: this.seedcode,
          search: this.searchdata,
          erpserial: this.searchErpserial
        }, this.buildFilterParams())
        if (this.searchDateRange && this.searchDateRange.length === 2) {
          params.startdate = this.searchDateRange[0]
          params.enddate = this.searchDateRange[1]
        }
        badpartsoutpage(params).then(response => {
          const pageData = response.data.obj || {}
          this.tableData5 = (pageData.rows || []).map(item => {
            const ps = this.parsePackagesize(item.packagesize)
            return { ...item, qj: ps.qj, zj: ps.zj, xh: ps.xh, sh: ps.sh }
          })
          this.pagination5.total = pageData.total || 0
        })
      },
      scanHandleShow() {
        this.$refs.BadScanHandle.show(this.cangkucode);
      },
      addstoragebad(type) {
        this.$refs.AddStorageBad.show()
        this.$refs.AddStorageBad.initData(type)
      },
      lookorder(row) {
        this.$refs.StorageBadDetail.initData(row, this.searchdata,this.date,this.jxcstoreData)
      },
      //保存成功后打开对应坏件入库单
      openDetail(item) {
        this.$refs.BaoSunDetail.show(item.erpserial, true)
      },
      bindGrid(rebindtip) {
        if (this.radio2 == 1) {//待入库
          this.tableData = [];
          this.oldradio = this.radio2;
          badpartslist(Object.assign({
            formtype: 78,
            cangkucode: this.cangkucode,
            search: this.searchdata,
            seedcode: this.seedcode,
            status: 10
          }, this.buildFilterParams())).then(response => {
            this.tableData = response.data.obj
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].packagesize = this.getPackagesize(this.tableData[i].packagesize);
            }
          }).catch((error) => {
            console.log(error)
          });
        } else if (this.radio2 == 2) {//待处理
          this.tableData = [];
          this.oldradio = this.radio2;
          badpartscount(Object.assign({
            cangkucode: this.cangkucode,
            search: this.searchdata,
            seedcode: this.seedcode
          }, this.buildFilterParams())).then(response => {
            this.tableData = response.data.obj
            this.clearZero();
          })
        } else if (this.radio2 == 3) {//待审核
          this.tableData = [];
          this.oldradio = this.radio2;
          badpartsauditlist(Object.assign({
            cangkucode: this.cangkucode
          }, this.buildFilterParams())).then(response => {
            this.tableData = (response.data.obj || []).map(item => {
              // 从 remark 解析用户备注和处理方式
              let userRemark = ''
              let handlemodeText = ''
              const remark = item.remark || ''
              if (remark.startsWith('[AUDIT]')) {
                const paramStr = remark.substring(7)
                const remarkIdx = paramStr.indexOf('|remark=')
                const paramsPart = remarkIdx >= 0 ? paramStr.substring(0, remarkIdx) : paramStr
                userRemark = remarkIdx >= 0 ? paramStr.substring(remarkIdx + 8) : ''
                const paramMap = {}
                paramsPart.split('|').forEach(kv => {
                  const parts = kv.split('=', 2)
                  if (parts.length === 2) paramMap[parts[0]] = parts[1]
                })
                const valueMap = {'5': '损耗', '10': '入正式库', '20': '退回供应商', '30': '转其他仓库'}
                handlemodeText = valueMap[paramMap['value']] || ''
              }
              return {
                ...item,
                remark: userRemark,
                handlemodeText: handlemodeText
              }
            })
          })
        } else if (this.radio2 == 4) {//坏件入库单
          this.pagination4.currentPage = 1
          if (!this.searchDateRange || this.searchDateRange.length !== 2) {
            this.searchDateRange = this.getDefaultDateRange()
          }
          this.loadTab4()
        } else if (this.radio2 == 5) {//坏件出库单
          this.pagination5.currentPage = 1
          if (!this.searchDateRange || this.searchDateRange.length !== 2) {
            this.searchDateRange = this.getDefaultDateRange()
          }
          this.loadTab5()
        } else {
          this.radio2 = this.oldradio;
          this.$refs.StorageBadSummary1.show(this);
        }

        if (rebindtip) {
          this.$emit("bindTip")
        }
      },
      clearZero(){
        var colms='tuihuo;zhuanru;zhiliang;jiagongbaosun;duofa;ruzhnegshiku;sunhao;thgys'.split(';')
        for(let i=0;i<this.tableData.length;i++) {
          for (let j = 0; j < colms.length; j++) {
            if(this.tableData[i][colms[j]]==0)
              this.tableData[i][colms[j]]=null;
          }
        }
      },
      //根据登录人过滤仓库
      cusandptbyind() {
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          this.cangkucode= this.jxcstoreData[0].cangkucode
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          }
          if (this.userInfoModel.independentserial == "") {//总部登录
            this.jxcstoreData.unshift({
              cangkuname: "全部仓库",
              cangkucode: ''
            })
          }
          this.bindGrid();
        })

      }
      ,
      //确认入库
      confirmruku(row) {
        this.$refs.BaoSunDetail.show(row.erpserial,true)
      },
      setNow(){
        this.date=new Date()
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = this.userInfoModel.independentserial;
      this.setNow();
      this.loadBrandList();

      checkModuleRight({name: 'qrcodescan'}).then(reponse => {
        this.qrcodescan = reponse.data.code == 0;
      });
      checkModuleRight({name: 'badoutaudit'}).then(reponse => {
        this.badoutaudit = reponse.data.code == 0;
      });
      //绑定仓库,绑定列表数据
      this.cusandptbyind()
    },
    components: {
      StorageBadSummary,
      StorageBadEdit,
      BadScanHandle,
      StorageBadDetail,
      AddStorageBad,
      JxcgooddetailSel,
      AddStorageBadFrame,
      AddStorageBadQRCode,
      BaoSunDetail,
      StorageBadAudit,
      StorageBadOut
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBad.vue